import { z } from "zod";

export const VendorItemSchema = z.object({
  Id: z.number(),
  Name: z.string(),
});

export type GlobalVendorItemType = z.infer<typeof VendorItemSchema>;
